import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCountryList,
  updateCountryList,
} from "../../../slices/LocationSlice/countrySlice";
import {
  fetchTierMap,
  updateTierMap,
} from "../../../slices/LocationSlice/tierMapSlice";
import { fetchOptionListData } from "../../../slices/LocationSlice/optionSlice";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import EditableTable from "./Table";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import { fetchLanguageList } from "../../../slices/panelSlice/languageSlice";
import SearchTable from "@/components/SearchTable";
import Add from "./Add";

import { fetchStateList } from "@/slices/LocationSlice/stateSlice";
import { fetchDistrictList } from "@/slices/LocationSlice/districtSlice";
import { fetchTierList } from "@/slices/LocationSlice/tierSlice";
import { fetchCityList } from "@/slices/LocationSlice/citySlice";

function TierMapper({editable}) {
  const dispatch = useDispatch();
  const { tierMapList, status, error } = useSelector(
    (state) => state.tierMapper
  );
  const country = useSelector((state) => state.countryList);
  const { data } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(tierMapList?.result)
    ? tierMapList?.result?.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(tierMapList?.result)
    ? Math.ceil(tierMapList?.result?.length / itemsPerPage)
    : 0;
  const headers =
    tierMapList?.result?.length > 0
      ? Object.keys(tierMapList.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = [
    "title",
    "status",
    "code",
    "val",
    "optionType",
    "City",
    "tier",
    "State",
    "Tier",
    "District",
  ]; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  const [addCountryModal, setAddCountryModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { optionList } = useSelector((state) => state.option);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredRows, setFilteredRows] = useState(currentItems);

  const state = useSelector((state) => state.state);
  const district = useSelector((state) => state.district);
  const city = useSelector((state) => state.city);
  const tier = useSelector((state) => state.tier);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchTierMap());
    }
    if (country.status === "idle") {
      dispatch(fetchCountryList());
    }
    dispatch(fetchLanguageList());
    dispatch(fetchOptionListData());

    if (state.status === "idle") dispatch(fetchStateList());
    if (city.status === "idle") dispatch(fetchCityList());
    dispatch(fetchDistrictList());
    if (tier.status === "idle") dispatch(fetchTierList());
  }, [dispatch]);

  // if (status === "loading") {
  //   return <Loader></Loader>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = tierMapList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  

  const handleSave = async () => {
    const { id, val, status } = editedData;
    const cityId = city.cityList.result.filter(
      (f) => f.title === editedData.City
    )[0].id;
    const tierId = tier.tierList.result.filter(
      (f) => f.title === editedData.Tier
    )[0].id;
    const stateId = state.stateList.result.filter(
      (f) => f.title === editedData.State
    )[0].id;
    const districtId = district.districtList.result.filter(
      (f) => f.title === editedData.District
    )[0].id;
    const updatedData = {
      id,
      Tier: tierId,
      val,
      status,
      City: cityId,
      State: stateId,
      District: districtId,
    };

    const resp = await dispatch(updateTierMap(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchTierMap());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field, val) => {
    if (["status", "active"].includes(field)) {
      setEditedData((prev) => ({
        ...prev,
        [field]: !val,
      }));
    } else {
      setEditedData((prev) => ({
        ...prev,
        [field]: e.target.value,
      }));
    }
  };

  const handleLog = (id) => {
    const logData = tierMapList.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };

  return (
    <div className="w-full flex items-center flex-col">
      <div className="w-11/12 flex justify-end">
        <SearchTable
          placeholder="Search for a tier..."
          data={currentItems}
          onSearchResults={setFilteredRows} // Update filtered list in parent
          className="m-2"
          allData={tierMapList?.result}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
      </div>

      <div className="max-w-full overflow-scroll">
        <EditableTable
          headers={headers}
          rows={currentItems}
          editRowId={editRowId}
          editedData={editedData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleChange={handleChange}
          handleLog={handleLog}
          editableFields={editableFields} // Pass editable fields
          optionList={optionList}
          languageList={data?.result}
          filteredRows={filteredRows}
          state={state.stateList.result}
          district={district.districtList.result}
          city={city.cityList.result}
          tier={tier.tierList.result}
          editable={editable}
        />
      </div>

      <div className="flex mt-4 items-center justify-between w-11/12">
        {searchQuery.length < 3 && (
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        )}

        {editable &&  <button
          className="activeBtn text-sm text-white  py-1 px-2 rounded"
          onClick={() => setAddCountryModal(true)}
        >
          + Add Tier Mapper
        </button>}
       
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

      <Modal
        isOpen={addCountryModal}
        onClose={() => setAddCountryModal(false)}
        title="Add Tier"
        content={
          <Add
            state={state.stateList.result}
            district={district.districtList.result}
            city={city.cityList.result}
            tier={tier.tierList.result}
          />
        }
      />
    </div>
  );
}

export default TierMapper;
